import React from "react"
import { FaWallet, FaTree, FaSocks } from "react-icons/fa"

export default [
  {
    icon: <FaWallet />,
    title: "saving money",
    text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Null",
  },
  {
    icon: <FaTree />,
    title: "endless hiking",
    text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Null",
  },
  {
    icon: <FaSocks />,
    title: "amazing comfort",
    text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Null",
  },
]
